<div class="wrapper-create-new-terms">
  <form class="grid" [formGroup]="termsFirstStepForm">
    <div class="grid__m-6">
      <div class="">
        <span class="terms-title">Kada je otvorena firma?</span>
        <div class="wrapper-checkbox-custom grid">
          <div class="grid__m-6" *ngFor="let day of daysOfWeek; index as i">
            <input class="checkbox-custom" type="checkbox" [id]="'checkbox-' + i" [value]="day.dayForDB"
              [checked]="initialCheckedDays.includes(day.dayForDB)" (change)="onDaysCheckboxChange($event)">
            <label class="checkbox-custom-label" [for]="'checkbox-' + i">{{day.dayForView}}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="grid__m-12">
      <button class="zc-btn zc-btn--primary" type="button" [disabled]="!selectedDays.length" (click)="saveDays()">
        <p>Sačuvaj</p>
      </button>
    </div>
  </form>
  <div class="grid">
    <div class="grid__m-12">
      <div class="wrapper-tabs-days">
        <div
          class="wrapper-tab-day"
          *ngFor="let day of daysOfWeek"
          [ngClass]="{ 'active': selectedSlot?.weekday === day.number }"
          [class.disabled]="!isSlotClickable(day)"
          (click)="selectSlot(day)"
        >
          <div class="wrapper-content-tab-day">
            <span class="label-day">
              {{ day.dayForView }}
            </span>
            <ng-container *ngIf="getWorkDay(day.number) as workDay">
              <span class="label-time">
                {{ workDay.work_from }} - {{ workDay.work_to }}
              </span>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="card-design">
        <div class="wrapper-working-hours" *ngIf="selectedSlot">
          <div class="zc-d-flex zc-justify-between zc-align-items">
            <span class="title1">Podešavanje za {{ selectedSlot.weekday | dayName }}</span>
            <button type="button" class="zc-btn zc-btn--primary" (click)="saveChanges()">
              <p>Sačuvaj radno vreme</p>
            </button>
          </div>
          <span class="subtitle1">Podesite radno vreme za ovaj dan</span>
          <div class="custom-wrapper-timepicker">
            <label>Od:</label>
            <input type="time" [(ngModel)]="selectedSlot.work_from">
            <label>Do:</label>
            <input type="time" [(ngModel)]="selectedSlot.work_to">
          </div>
          <div>
            <button type="button" class="zc-btn zc-btn--primary" (click)="addTimeRow()">
              <p>+ Dodaj termin</p>
            </button>
            <div *ngIf="isAddTimeSlotVisible" class="wrapper-add-new-terms"
              style="margin-top: 15px; border: 1px solid #ccc; padding: 10px;">
              <div *ngFor="let slot of newTimeSlots; let i = index">
                <div class="custom-wrapper-timepicker" [style.color]="isSlotWithinWorkingHours(slot) ? 'black' : 'red'"
                  style="margin: 8px 0px;">
                  <label>Od:</label>
                  <input type="time" [(ngModel)]="slot.start_time">
                  <label>Do:</label>
                  <input type="time" [(ngModel)]="slot.end_time">
                  <button type="button" (click)="removeTimeRow(i)" type="submit" class="zc-btn zc-btn--delete"
                    style="height: 36px; margin-left: 8px;">
                    <span>Obriši</span>
                  </button>
                  <div *ngIf="!isSlotWithinWorkingHours(slot)" style="font-size: 11px; color: red;">
                    Termin mora biti između {{selectedSlot.work_from}} i {{selectedSlot.work_to}}
                  </div>
                </div>
              </div>
              <hr>
              <button type="button" class="zc-btn zc-btn--primary xs-mr-10" (click)="saveAllTimeSlots(selectedSlot.id)"
                [disabled]="newTimeSlots.length === 0 || !allSlotsValid()">
                <span>Sačuvaj sve termine</span>
              </button>
              <button type="button" class="zc-btn zc-btn--outline"
                (click)="isAddTimeSlotVisible = false; newTimeSlots = []"><span>Odustani</span></button>
            </div>
          </div>
        </div>
        <div class="wrapper-lists-terms" *ngIf="selectedSlot && workingDayInfo">
          <div class="working-day-container">
            <h3 class="title1">Termini za {{ selectedSlot.weekday | dayName }}</h3>

            <div *ngFor="let info of workingDayInfo; let i = index" class="slot-item">
              <div class="wrapper-slot-time">
                <div class="preview-section" title="Klikni za detalje">
                  <span class="subtitle1"><strong>Termin #{{ i + 1 }}:</strong> {{info.start_time}} -
                    {{info.end_time}}</span>
                </div>
              </div>
              <div class="edit-section" [style.color]="isSlotWithinWorkingHours(info) ? 'inherit' : 'red'">
                <div class="custom-wrapper-timepicker" style="margin: 8px 0px;">
                  <input type="time" [(ngModel)]="info.start_time">
                  <span> do </span>
                  <input type="time" [(ngModel)]="info.end_time">
                  <button type="button" class="zc-btn zc-btn--delete" style="height: 34px; margin-left: 8px;"
                    (click)="openRemoveTermMOdal(i, selectedSlot.id)"><span>Obriši</span></button>
                </div>
                <div *ngIf="!isSlotWithinWorkingHours(info)" class="error-text">
                  Van radnog vremena ({{selectedSlot.work_from}} - {{selectedSlot.work_to}})
                </div>
              </div>
              <button type="button" class="zc-btn zc-btn--primary" style="height: 34px; margin-left: 8px"
                (click)="selectDaySlott(info)"><span>Slotovi</span></button>
            </div>
            <div class="form-actions">
              <button type="button" class="zc-btn zc-btn--primary"
                (click)="saveeeChanges(selectedSlot.id)"><span>Sačuvaj sve izmene</span></button>
            </div>
          </div>

          <div *ngIf="selectDaySlot" class="wrapper-add-slot">
            <h3 class="title1">Slotovi za {{ selectDaySlot.start_time | slice:0:5 }} - {{ selectDaySlot.end_time |
              slice:0:5 }}</h3>
            <hr>
            <button type="button" class="zc-btn zc-btn--primary" (click)="addSubSlotRow()"><span>Dodaj novu
                uslugu/slot</span></button>
            <div *ngIf="isAddSubSlotVisible"
              style="margin-top: 10px; background: #f4f4f4; padding: 15px; border-radius: 4px;">
              <div *ngFor="let s of editableSlots; let j = index"
                style="margin-bottom: 15px; border-bottom: 1px solid #ccc; padding-bottom: 10px;">
                <div class="wrapper-input">
                  <span class="label-input">Naziv (Opis):</span>
                  <div class="zc-textarea" style="margin-bottom: 32px;">
                    <textarea type="text" [(ngModel)]="s.description"></textarea>
                  </div>
                </div>
                <div class="input-group" style="margin-top: 5px;">
                  <div class="wrapper-input">
                    <span class="label-input">Osnovna cena:</span>
                    <div class="zc-input">
                      <input type="number" [(ngModel)]="s.base_price">
                    </div>
                  </div>
                  <div class="wrapper-input">
                    <span class="label-input">Max mesta:</span>
                    <div class="zc-input">
                      <input type="number" [(ngModel)]="s.max_bookings">
                    </div>
                  </div>
                  <button type="button" class="zc-btn zc-btn--delete"
                    (click)="openRemoveSlotMOdal(j, s, selectedSlot.id);">Obriši</button>
                </div>
              </div>
              <!--          [disabled]="newSubSlots.length === 0 || !allSubSlotsValid()"-->
              <div style="margin-top: 10px;">
                <button type="button" class="zc-btn zc-btn--primary" style="margin-right: 16px;"
                  (click)="saveSubSlots()">
                  <span>Sačuvaj sve slotove</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="grid wrapper-custom-calendars">
    <div class="grid__m-6">
      <span class="terms-title">Slobodni termini</span>
      <span class="terms-subtitle">Kalendar pokazuje, u plavom okviru sve dane kada je igraonica otvorena, s slobodnim
      terminima. Ukoliko neki dan igraonica ne radi, možete manuelno “zatvoriti” taj dan klikom na datum.</span>
      <div class="wrapper-datepicker">
        <mat-card class="demo-inline-calendar-card">
          <mat-calendar tabindex="-1" class="booking-calendar" #calendar [dateClass]="dateClass" [selected]="selected"
                        [minDate]="minDate" [dateFilter]="filteredDate1"
                        (selectedChange)="onCalendarDateChange($event)"></mat-calendar>
        </mat-card>
      </div>
    </div>
    <div class="grid__m-6">
      <span class="terms-title">Definiši drugu cenu termina</span>
      <span class="terms-subtitle">
      Ukoliko nekim danima cena je skuplja od minimalne cene, odaberite dan i termin i promenite cenu ručno.</span>
      <div class="wrapper-datepicker">
        <mat-card class="demo-inline-calendar-card">
          <mat-calendar tabindex="-1" #calendar2 [selected]="selected2" [minDate]="minDate" [dateFilter]="filteredDate2"
                        (selectedChange)="onSetCustomPriceCalendarDateChange($event)"></mat-calendar>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<gr-change-work-terms-modal *ngIf="isChangeWorkTermsModalOpen" [urlParams]="urlParams"
  [selectedDateKey]="selectedDateKey" [selectedDayName]="selectedDayName" [newSlotsSelectedDateKey]="selectedDateKey"
  [selectedTermsDate]="selectedDayData" (closeModal)="isChangeWorkTermsModalOpen = false; selected = null"
  (confirmModal)="isChangeWorkTermsModalOpen = false; selected = null"></gr-change-work-terms-modal>

<app-custom-slot-price *ngIf="isSetCustomPriceModalOpen" [urlParams]="urlParams" [daySlots]="daySlots"
  [setCustomSelectedDateKey]="setCustomSelectedDateKey" [setCustomSelectedDayName]="setCustomSelectedDayName"
  [setCustomSelectedDayData]="setCustomSelectedDayData" (closeModal)="isSetCustomPriceModalOpen = false"
  (confirmModal)="isSetCustomPriceModalOpen = false"></app-custom-slot-price>

<gr-confirm-modal *ngIf="removeTermId !== null" [modalTitle]="'Brisanje termina'"
  [modalDescription]="'Da li ste sigurni da zelite da obrišete termin?'"
  (closeModal)="removeTermId = null; removeTermIndex = null" (confirmModal)="removeeTimeRow()"></gr-confirm-modal>

<gr-confirm-modal *ngIf="removeSlotIndex !== null" [modalTitle]="'Brisanje slota'"
  [modalDescription]="'Da li ste sigurni da zelite da obrišete slot?'"
  (closeModal)="removeSlotId = null; removeSlotIndex = null" (confirmModal)="removeeSlotRow()"></gr-confirm-modal>
